module.exports = __webpack_public_path__ + "media/customizations/regencyatmontaine/back-9765ee72e6f862f564ba1b5e4bb672e9.jpg";